import { Box, Stack, SvgIcon, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const RecipientsSection = () => {
  const getNonExpandedView = () => {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ opacity: 0.5 }}
      >
        <Stack direction="row" spacing={4}>
          <SvgIcon>
            <CheckCircleIcon htmlColor={"#7551D0"} />
          </SvgIcon>
          <Stack spacing={0.5}>
            <Typography variant="h4">Recipients</Typography>
            <Typography variant="body1">
              Select your target audience for better engagement
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  };

  const getPage = () => {
    return getNonExpandedView();
  };

  return <Box px={3}>{getPage()}</Box>;
};

export default RecipientsSection;
